import { Schedule } from "@/types/branch";
import { availableDaysIdx, formatAvailability, isAvailableToday } from "@/utils/weekDays";
import { Appointment02Icon, CalendarRemove02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Stack, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

interface Props {
  availability?: Schedule;
}

const ScheduleAvailability = ({ availability }: Props) => {
  const { palette } = useTheme();
  const formattedSchedule = formatAvailability(availability);

  const isAvailable = useMemo(() => {
    return isAvailableToday(availability);
  }, [availability]);

  if (availableDaysIdx(availability).length === 0) {
    return null;
  }

  return (
    <Stack gap={1} direction={"row"} alignItems="center">
      {isAvailable ? (
        <HugeiconsIcon size={20} icon={Appointment02Icon} color={palette.success.main} strokeWidth={1.5} />
      ) : (
        <HugeiconsIcon size={20} icon={CalendarRemove02Icon} color={palette.error.main} strokeWidth={1.5} />
      )}

      <Typography variant="body2" lineHeight={1}>
        {formattedSchedule}
      </Typography>
    </Stack>
  );
};

export default ScheduleAvailability;
